

if (typeof ENV !== 'undefined' && ENV.MOMENT_LOCALE && ENV.MOMENT_LOCALE !== 'en') {
  function loadLocale(locale) {
    switch (locale) {
      
        case "moment/locale/af": return import(/* webpackChunkName: "moment/locale/af" */ "moment/locale/af.js");
      
        case "moment/locale/ar-dz": return import(/* webpackChunkName: "moment/locale/ar-dz" */ "moment/locale/ar-dz.js");
      
        case "moment/locale/ar-kw": return import(/* webpackChunkName: "moment/locale/ar-kw" */ "moment/locale/ar-kw.js");
      
        case "moment/locale/ar-ly": return import(/* webpackChunkName: "moment/locale/ar-ly" */ "moment/locale/ar-ly.js");
      
        case "moment/locale/ar-ma": return import(/* webpackChunkName: "moment/locale/ar-ma" */ "moment/locale/ar-ma.js");
      
        case "moment/locale/ar-sa": return import(/* webpackChunkName: "moment/locale/ar-sa" */ "moment/locale/ar-sa.js");
      
        case "moment/locale/ar-tn": return import(/* webpackChunkName: "moment/locale/ar-tn" */ "moment/locale/ar-tn.js");
      
        case "moment/locale/ar": return import(/* webpackChunkName: "moment/locale/ar" */ "moment/locale/ar.js");
      
        case "moment/locale/az": return import(/* webpackChunkName: "moment/locale/az" */ "moment/locale/az.js");
      
        case "moment/locale/be": return import(/* webpackChunkName: "moment/locale/be" */ "moment/locale/be.js");
      
        case "moment/locale/bg": return import(/* webpackChunkName: "moment/locale/bg" */ "moment/locale/bg.js");
      
        case "moment/locale/bm": return import(/* webpackChunkName: "moment/locale/bm" */ "moment/locale/bm.js");
      
        case "moment/locale/bn": return import(/* webpackChunkName: "moment/locale/bn" */ "moment/locale/bn.js");
      
        case "moment/locale/bo": return import(/* webpackChunkName: "moment/locale/bo" */ "moment/locale/bo.js");
      
        case "moment/locale/br": return import(/* webpackChunkName: "moment/locale/br" */ "moment/locale/br.js");
      
        case "moment/locale/bs": return import(/* webpackChunkName: "moment/locale/bs" */ "moment/locale/bs.js");
      
        case "moment/locale/ca": return import(/* webpackChunkName: "moment/locale/ca" */ "moment/locale/ca.js");
      
        case "moment/locale/cs": return import(/* webpackChunkName: "moment/locale/cs" */ "moment/locale/cs.js");
      
        case "moment/locale/cv": return import(/* webpackChunkName: "moment/locale/cv" */ "moment/locale/cv.js");
      
        case "moment/locale/cy": return import(/* webpackChunkName: "moment/locale/cy" */ "moment/locale/cy.js");
      
        case "moment/locale/da": return import(/* webpackChunkName: "moment/locale/da" */ "moment/locale/da.js");
      
        case "moment/locale/de-at": return import(/* webpackChunkName: "moment/locale/de-at" */ "moment/locale/de-at.js");
      
        case "moment/locale/de-ch": return import(/* webpackChunkName: "moment/locale/de-ch" */ "moment/locale/de-ch.js");
      
        case "moment/locale/dv": return import(/* webpackChunkName: "moment/locale/dv" */ "moment/locale/dv.js");
      
        case "moment/locale/el": return import(/* webpackChunkName: "moment/locale/el" */ "moment/locale/el.js");
      
        case "moment/locale/en-au": return import(/* webpackChunkName: "moment/locale/en-au" */ "moment/locale/en-au.js");
      
        case "moment/locale/en-ca": return import(/* webpackChunkName: "moment/locale/en-ca" */ "moment/locale/en-ca.js");
      
        case "moment/locale/en-gb": return import(/* webpackChunkName: "moment/locale/en-gb" */ "moment/locale/en-gb.js");
      
        case "moment/locale/en-ie": return import(/* webpackChunkName: "moment/locale/en-ie" */ "moment/locale/en-ie.js");
      
        case "moment/locale/en-il": return import(/* webpackChunkName: "moment/locale/en-il" */ "moment/locale/en-il.js");
      
        case "moment/locale/en-nz": return import(/* webpackChunkName: "moment/locale/en-nz" */ "moment/locale/en-nz.js");
      
        case "moment/locale/en-SG": return import(/* webpackChunkName: "moment/locale/en-SG" */ "moment/locale/en-SG.js");
      
        case "moment/locale/eo": return import(/* webpackChunkName: "moment/locale/eo" */ "moment/locale/eo.js");
      
        case "moment/locale/es-do": return import(/* webpackChunkName: "moment/locale/es-do" */ "moment/locale/es-do.js");
      
        case "moment/locale/es-us": return import(/* webpackChunkName: "moment/locale/es-us" */ "moment/locale/es-us.js");
      
        case "moment/locale/es": return import(/* webpackChunkName: "moment/locale/es" */ "moment/locale/es.js");
      
        case "moment/locale/et": return import(/* webpackChunkName: "moment/locale/et" */ "moment/locale/et.js");
      
        case "moment/locale/eu": return import(/* webpackChunkName: "moment/locale/eu" */ "moment/locale/eu.js");
      
        case "moment/locale/fi": return import(/* webpackChunkName: "moment/locale/fi" */ "moment/locale/fi.js");
      
        case "moment/locale/fo": return import(/* webpackChunkName: "moment/locale/fo" */ "moment/locale/fo.js");
      
        case "moment/locale/fr-ch": return import(/* webpackChunkName: "moment/locale/fr-ch" */ "moment/locale/fr-ch.js");
      
        case "moment/locale/fy": return import(/* webpackChunkName: "moment/locale/fy" */ "moment/locale/fy.js");
      
        case "moment/locale/ga": return import(/* webpackChunkName: "moment/locale/ga" */ "moment/locale/ga.js");
      
        case "moment/locale/gd": return import(/* webpackChunkName: "moment/locale/gd" */ "moment/locale/gd.js");
      
        case "moment/locale/gl": return import(/* webpackChunkName: "moment/locale/gl" */ "moment/locale/gl.js");
      
        case "moment/locale/gom-latn": return import(/* webpackChunkName: "moment/locale/gom-latn" */ "moment/locale/gom-latn.js");
      
        case "moment/locale/gu": return import(/* webpackChunkName: "moment/locale/gu" */ "moment/locale/gu.js");
      
        case "moment/locale/hi": return import(/* webpackChunkName: "moment/locale/hi" */ "moment/locale/hi.js");
      
        case "moment/locale/hr": return import(/* webpackChunkName: "moment/locale/hr" */ "moment/locale/hr.js");
      
        case "moment/locale/hu": return import(/* webpackChunkName: "moment/locale/hu" */ "moment/locale/hu.js");
      
        case "moment/locale/id": return import(/* webpackChunkName: "moment/locale/id" */ "moment/locale/id.js");
      
        case "moment/locale/is": return import(/* webpackChunkName: "moment/locale/is" */ "moment/locale/is.js");
      
        case "moment/locale/it-ch": return import(/* webpackChunkName: "moment/locale/it-ch" */ "moment/locale/it-ch.js");
      
        case "moment/locale/it": return import(/* webpackChunkName: "moment/locale/it" */ "moment/locale/it.js");
      
        case "moment/locale/ja": return import(/* webpackChunkName: "moment/locale/ja" */ "moment/locale/ja.js");
      
        case "moment/locale/jv": return import(/* webpackChunkName: "moment/locale/jv" */ "moment/locale/jv.js");
      
        case "moment/locale/ka": return import(/* webpackChunkName: "moment/locale/ka" */ "moment/locale/ka.js");
      
        case "moment/locale/kk": return import(/* webpackChunkName: "moment/locale/kk" */ "moment/locale/kk.js");
      
        case "moment/locale/km": return import(/* webpackChunkName: "moment/locale/km" */ "moment/locale/km.js");
      
        case "moment/locale/kn": return import(/* webpackChunkName: "moment/locale/kn" */ "moment/locale/kn.js");
      
        case "moment/locale/ko": return import(/* webpackChunkName: "moment/locale/ko" */ "moment/locale/ko.js");
      
        case "moment/locale/ku": return import(/* webpackChunkName: "moment/locale/ku" */ "moment/locale/ku.js");
      
        case "moment/locale/ky": return import(/* webpackChunkName: "moment/locale/ky" */ "moment/locale/ky.js");
      
        case "moment/locale/lb": return import(/* webpackChunkName: "moment/locale/lb" */ "moment/locale/lb.js");
      
        case "moment/locale/lo": return import(/* webpackChunkName: "moment/locale/lo" */ "moment/locale/lo.js");
      
        case "moment/locale/lt": return import(/* webpackChunkName: "moment/locale/lt" */ "moment/locale/lt.js");
      
        case "moment/locale/lv": return import(/* webpackChunkName: "moment/locale/lv" */ "moment/locale/lv.js");
      
        case "moment/locale/me": return import(/* webpackChunkName: "moment/locale/me" */ "moment/locale/me.js");
      
        case "moment/locale/mi": return import(/* webpackChunkName: "moment/locale/mi" */ "moment/locale/mi.js");
      
        case "moment/locale/mk": return import(/* webpackChunkName: "moment/locale/mk" */ "moment/locale/mk.js");
      
        case "moment/locale/ml": return import(/* webpackChunkName: "moment/locale/ml" */ "moment/locale/ml.js");
      
        case "moment/locale/mn": return import(/* webpackChunkName: "moment/locale/mn" */ "moment/locale/mn.js");
      
        case "moment/locale/mr": return import(/* webpackChunkName: "moment/locale/mr" */ "moment/locale/mr.js");
      
        case "moment/locale/ms-my": return import(/* webpackChunkName: "moment/locale/ms-my" */ "moment/locale/ms-my.js");
      
        case "moment/locale/ms": return import(/* webpackChunkName: "moment/locale/ms" */ "moment/locale/ms.js");
      
        case "moment/locale/mt": return import(/* webpackChunkName: "moment/locale/mt" */ "moment/locale/mt.js");
      
        case "moment/locale/my": return import(/* webpackChunkName: "moment/locale/my" */ "moment/locale/my.js");
      
        case "moment/locale/nb": return import(/* webpackChunkName: "moment/locale/nb" */ "moment/locale/nb.js");
      
        case "moment/locale/ne": return import(/* webpackChunkName: "moment/locale/ne" */ "moment/locale/ne.js");
      
        case "moment/locale/nl-be": return import(/* webpackChunkName: "moment/locale/nl-be" */ "moment/locale/nl-be.js");
      
        case "moment/locale/nl": return import(/* webpackChunkName: "moment/locale/nl" */ "moment/locale/nl.js");
      
        case "moment/locale/nn": return import(/* webpackChunkName: "moment/locale/nn" */ "moment/locale/nn.js");
      
        case "moment/locale/pa-in": return import(/* webpackChunkName: "moment/locale/pa-in" */ "moment/locale/pa-in.js");
      
        case "moment/locale/pt-br": return import(/* webpackChunkName: "moment/locale/pt-br" */ "moment/locale/pt-br.js");
      
        case "moment/locale/pt": return import(/* webpackChunkName: "moment/locale/pt" */ "moment/locale/pt.js");
      
        case "moment/locale/ro": return import(/* webpackChunkName: "moment/locale/ro" */ "moment/locale/ro.js");
      
        case "moment/locale/ru": return import(/* webpackChunkName: "moment/locale/ru" */ "moment/locale/ru.js");
      
        case "moment/locale/sd": return import(/* webpackChunkName: "moment/locale/sd" */ "moment/locale/sd.js");
      
        case "moment/locale/se": return import(/* webpackChunkName: "moment/locale/se" */ "moment/locale/se.js");
      
        case "moment/locale/si": return import(/* webpackChunkName: "moment/locale/si" */ "moment/locale/si.js");
      
        case "moment/locale/sk": return import(/* webpackChunkName: "moment/locale/sk" */ "moment/locale/sk.js");
      
        case "moment/locale/sq": return import(/* webpackChunkName: "moment/locale/sq" */ "moment/locale/sq.js");
      
        case "moment/locale/sr-cyrl": return import(/* webpackChunkName: "moment/locale/sr-cyrl" */ "moment/locale/sr-cyrl.js");
      
        case "moment/locale/sr": return import(/* webpackChunkName: "moment/locale/sr" */ "moment/locale/sr.js");
      
        case "moment/locale/ss": return import(/* webpackChunkName: "moment/locale/ss" */ "moment/locale/ss.js");
      
        case "moment/locale/sv": return import(/* webpackChunkName: "moment/locale/sv" */ "moment/locale/sv.js");
      
        case "moment/locale/sw": return import(/* webpackChunkName: "moment/locale/sw" */ "moment/locale/sw.js");
      
        case "moment/locale/ta": return import(/* webpackChunkName: "moment/locale/ta" */ "moment/locale/ta.js");
      
        case "moment/locale/te": return import(/* webpackChunkName: "moment/locale/te" */ "moment/locale/te.js");
      
        case "moment/locale/tet": return import(/* webpackChunkName: "moment/locale/tet" */ "moment/locale/tet.js");
      
        case "moment/locale/tg": return import(/* webpackChunkName: "moment/locale/tg" */ "moment/locale/tg.js");
      
        case "moment/locale/th": return import(/* webpackChunkName: "moment/locale/th" */ "moment/locale/th.js");
      
        case "moment/locale/tl-ph": return import(/* webpackChunkName: "moment/locale/tl-ph" */ "moment/locale/tl-ph.js");
      
        case "moment/locale/tlh": return import(/* webpackChunkName: "moment/locale/tlh" */ "moment/locale/tlh.js");
      
        case "moment/locale/tr": return import(/* webpackChunkName: "moment/locale/tr" */ "moment/locale/tr.js");
      
        case "moment/locale/tzl": return import(/* webpackChunkName: "moment/locale/tzl" */ "moment/locale/tzl.js");
      
        case "moment/locale/tzm-latn": return import(/* webpackChunkName: "moment/locale/tzm-latn" */ "moment/locale/tzm-latn.js");
      
        case "moment/locale/tzm": return import(/* webpackChunkName: "moment/locale/tzm" */ "moment/locale/tzm.js");
      
        case "moment/locale/ug-cn": return import(/* webpackChunkName: "moment/locale/ug-cn" */ "moment/locale/ug-cn.js");
      
        case "moment/locale/uk": return import(/* webpackChunkName: "moment/locale/uk" */ "moment/locale/uk.js");
      
        case "moment/locale/ur": return import(/* webpackChunkName: "moment/locale/ur" */ "moment/locale/ur.js");
      
        case "moment/locale/uz-latn": return import(/* webpackChunkName: "moment/locale/uz-latn" */ "moment/locale/uz-latn.js");
      
        case "moment/locale/uz": return import(/* webpackChunkName: "moment/locale/uz" */ "moment/locale/uz.js");
      
        case "moment/locale/vi": return import(/* webpackChunkName: "moment/locale/vi" */ "moment/locale/vi.js");
      
        case "moment/locale/x-pseudo": return import(/* webpackChunkName: "moment/locale/x-pseudo" */ "moment/locale/x-pseudo.js");
      
        case "moment/locale/yo": return import(/* webpackChunkName: "moment/locale/yo" */ "moment/locale/yo.js");
      
        case "moment/locale/zh-cn": return import(/* webpackChunkName: "moment/locale/zh-cn" */ "moment/locale/zh-cn.js");
      
        case "moment/locale/zh-hk": return import(/* webpackChunkName: "moment/locale/zh-hk" */ "moment/locale/zh-hk.js");
      
        case "moment/locale/zh-tw": return import(/* webpackChunkName: "moment/locale/zh-tw" */ "moment/locale/zh-tw.js");
      
        case "moment/locale/de": return import(/* webpackChunkName: "moment/locale/de" */ "custom_moment_locales/de.js");
      
        case "moment/locale/fa": return import(/* webpackChunkName: "moment/locale/fa" */ "custom_moment_locales/fa.js");
      
        case "moment/locale/fr": return import(/* webpackChunkName: "moment/locale/fr" */ "custom_moment_locales/fr.js");
      
        case "moment/locale/fr-ca": return import(/* webpackChunkName: "moment/locale/fr-ca" */ "custom_moment_locales/fr_ca.js");
      
        case "moment/locale/he": return import(/* webpackChunkName: "moment/locale/he" */ "custom_moment_locales/he.js");
      
        case "moment/locale/ht-ht": return import(/* webpackChunkName: "moment/locale/ht-ht" */ "custom_moment_locales/ht_ht.js");
      
        case "moment/locale/hy-am": return import(/* webpackChunkName: "moment/locale/hy-am" */ "custom_moment_locales/hy_am.js");
      
        case "moment/locale/mi-nz": return import(/* webpackChunkName: "moment/locale/mi-nz" */ "custom_moment_locales/mi_nz.js");
      
        case "moment/locale/pl": return import(/* webpackChunkName: "moment/locale/pl" */ "custom_moment_locales/pl.js");
      
        case "moment/locale/sl": return import(/* webpackChunkName: "moment/locale/sl" */ "custom_moment_locales/sl.js");
      

      default:
        console.warn("couldn't load moment/locale/", locale)
    }
  }
  loadLocale('moment/locale/' + ENV.MOMENT_LOCALE)
}

export default function loadBundle(bundleName) {
  switch (bundleName) {
    
      case "grade_summary": return import(/* webpackChunkName: "grade_summary" */ "../app/coffeescripts/bundles/grade_summary.js");
    
      case "legacy/assignments_peer_reviews": return import(/* webpackChunkName: "legacy/assignments_peer_reviews" */ "../app/coffeescripts/bundles/legacy/assignments_peer_reviews.js");
    
      case "legacy/context_media_object_inline": return import(/* webpackChunkName: "legacy/context_media_object_inline" */ "../app/coffeescripts/bundles/legacy/context_media_object_inline.js");
    
      case "legacy/context_roster_usage": return import(/* webpackChunkName: "legacy/context_roster_usage" */ "../app/coffeescripts/bundles/legacy/context_roster_usage.js");
    
      case "legacy/context_roster_user_services": return import(/* webpackChunkName: "legacy/context_roster_user_services" */ "../app/coffeescripts/bundles/legacy/context_roster_user_services.js");
    
      case "legacy/context_roster_user": return import(/* webpackChunkName: "legacy/context_roster_user" */ "../app/coffeescripts/bundles/legacy/context_roster_user.js");
    
      case "legacy/context_undelete_item": return import(/* webpackChunkName: "legacy/context_undelete_item" */ "../app/coffeescripts/bundles/legacy/context_undelete_item.js");
    
      case "legacy/courses_show": return import(/* webpackChunkName: "legacy/courses_show" */ "../app/coffeescripts/bundles/legacy/courses_show.js");
    
      case "legacy/eportfolios_wizard_box": return import(/* webpackChunkName: "legacy/eportfolios_wizard_box" */ "../app/coffeescripts/bundles/legacy/eportfolios_wizard_box.js");
    
      case "legacy/error_form": return import(/* webpackChunkName: "legacy/error_form" */ "../app/coffeescripts/bundles/legacy/error_form.js");
    
      case "legacy/external_content_cancel": return import(/* webpackChunkName: "legacy/external_content_cancel" */ "../app/coffeescripts/bundles/legacy/external_content_cancel.js");
    
      case "legacy/external_content_success": return import(/* webpackChunkName: "legacy/external_content_success" */ "../app/coffeescripts/bundles/legacy/external_content_success.js");
    
      case "legacy/external_tools_tool_show": return import(/* webpackChunkName: "legacy/external_tools_tool_show" */ "../app/coffeescripts/bundles/legacy/external_tools_tool_show.js");
    
      case "legacy/inlined_preview": return import(/* webpackChunkName: "legacy/inlined_preview" */ "../app/coffeescripts/bundles/legacy/inlined_preview.js");
    
      case "legacy/quiz_submission": return import(/* webpackChunkName: "legacy/quiz_submission" */ "../app/coffeescripts/bundles/legacy/quiz_submission.js");
    
      case "legacy/rubrics_index": return import(/* webpackChunkName: "legacy/rubrics_index" */ "../app/coffeescripts/bundles/legacy/rubrics_index.js");
    
      case "legacy/rubrics_show": return import(/* webpackChunkName: "legacy/rubrics_show" */ "../app/coffeescripts/bundles/legacy/rubrics_show.js");
    
      case "legacy/submissions_show_preview_media": return import(/* webpackChunkName: "legacy/submissions_show_preview_media" */ "../app/coffeescripts/bundles/legacy/submissions_show_preview_media.js");
    
      case "legacy/submissions_show_preview_text": return import(/* webpackChunkName: "legacy/submissions_show_preview_text" */ "../app/coffeescripts/bundles/legacy/submissions_show_preview_text.js");
    
      case "legacy/submissions_show_preview_upload": return import(/* webpackChunkName: "legacy/submissions_show_preview_upload" */ "../app/coffeescripts/bundles/legacy/submissions_show_preview_upload.js");
    
      case "legacy/terms_index": return import(/* webpackChunkName: "legacy/terms_index" */ "../app/coffeescripts/bundles/legacy/terms_index.js");
    
      case "legacy/user_outcome_results": return import(/* webpackChunkName: "legacy/user_outcome_results" */ "../app/coffeescripts/bundles/legacy/user_outcome_results.js");
    
      case "legacy/users_admin_merge": return import(/* webpackChunkName: "legacy/users_admin_merge" */ "../app/coffeescripts/bundles/legacy/users_admin_merge.js");
    
      case "legacy/users_index": return import(/* webpackChunkName: "legacy/users_index" */ "../app/coffeescripts/bundles/legacy/users_index.js");
    
      case "account_admin_tools": return import(/* webpackChunkName: "account_admin_tools" */ "../app/jsx/bundles/account_admin_tools.js");
    
      case "account_course_user_search": return import(/* webpackChunkName: "account_course_user_search" */ "../app/jsx/bundles/account_course_user_search.js");
    
      case "account_grading_standards": return import(/* webpackChunkName: "account_grading_standards" */ "../app/jsx/bundles/account_grading_standards.js");
    
      case "account_search": return import(/* webpackChunkName: "account_search" */ "../app/jsx/bundles/account_search.js");
    
      case "account_settings": return import(/* webpackChunkName: "account_settings" */ "../app/jsx/bundles/account_settings.js");
    
      case "account_show": return import(/* webpackChunkName: "account_show" */ "../app/jsx/bundles/account_show.js");
    
      case "account_statistics": return import(/* webpackChunkName: "account_statistics" */ "../app/jsx/bundles/account_statistics.js");
    
      case "act_as_modal": return import(/* webpackChunkName: "act_as_modal" */ "../app/jsx/bundles/act_as_modal.js");
    
      case "add_course_or_user": return import(/* webpackChunkName: "add_course_or_user" */ "../app/jsx/bundles/add_course_or_user.js");
    
      case "alerts": return import(/* webpackChunkName: "alerts" */ "../app/jsx/bundles/alerts.js");
    
      case "all_courses": return import(/* webpackChunkName: "all_courses" */ "../app/jsx/bundles/all_courses.js");
    
      case "announcements_index_v2": return import(/* webpackChunkName: "announcements_index_v2" */ "../app/jsx/bundles/announcements_index_v2.js");
    
      case "announcements_on_home_page": return import(/* webpackChunkName: "announcements_on_home_page" */ "../app/jsx/bundles/announcements_on_home_page.js");
    
      case "assignment_edit": return import(/* webpackChunkName: "assignment_edit" */ "../app/jsx/bundles/assignment_edit.js");
    
      case "assignment_grade_summary": return import(/* webpackChunkName: "assignment_grade_summary" */ "../app/jsx/bundles/assignment_grade_summary.js");
    
      case "assignment_index": return import(/* webpackChunkName: "assignment_index" */ "../app/jsx/bundles/assignment_index.js");
    
      case "assignment_show": return import(/* webpackChunkName: "assignment_show" */ "../app/jsx/bundles/assignment_show.js");
    
      case "assignments_2_show_student": return import(/* webpackChunkName: "assignments_2_show_student" */ "../app/jsx/bundles/assignments_2_show_student.js");
    
      case "assignments_2_show_teacher": return import(/* webpackChunkName: "assignments_2_show_teacher" */ "../app/jsx/bundles/assignments_2_show_teacher.js");
    
      case "authentication_providers": return import(/* webpackChunkName: "authentication_providers" */ "../app/jsx/bundles/authentication_providers.js");
    
      case "blueprint_course_child": return import(/* webpackChunkName: "blueprint_course_child" */ "../app/jsx/bundles/blueprint_course_child.js");
    
      case "blueprint_course_master": return import(/* webpackChunkName: "blueprint_course_master" */ "../app/jsx/bundles/blueprint_course_master.js");
    
      case "brand_configs_index": return import(/* webpackChunkName: "brand_configs_index" */ "../app/jsx/bundles/brand_configs_index.js");
    
      case "calendar_appointment_group_edit": return import(/* webpackChunkName: "calendar_appointment_group_edit" */ "../app/jsx/bundles/calendar_appointment_group_edit.js");
    
      case "calendar2": return import(/* webpackChunkName: "calendar2" */ "../app/jsx/bundles/calendar2.js");
    
      case "change_password": return import(/* webpackChunkName: "change_password" */ "../app/jsx/bundles/change_password.js");
    
      case "choose_mastery_path": return import(/* webpackChunkName: "choose_mastery_path" */ "../app/jsx/bundles/choose_mastery_path.js");
    
      case "collaborations": return import(/* webpackChunkName: "collaborations" */ "../app/jsx/bundles/collaborations.js");
    
      case "conferences": return import(/* webpackChunkName: "conferences" */ "../app/jsx/bundles/conferences.js");
    
      case "confirm_email": return import(/* webpackChunkName: "confirm_email" */ "../app/jsx/bundles/confirm_email.js");
    
      case "content_exports": return import(/* webpackChunkName: "content_exports" */ "../app/jsx/bundles/content_exports.js");
    
      case "content_migration": return import(/* webpackChunkName: "content_migration" */ "../app/jsx/bundles/content_migration.js");
    
      case "content_notices": return import(/* webpackChunkName: "content_notices" */ "../app/jsx/bundles/content_notices.js");
    
      case "content_shares": return import(/* webpackChunkName: "content_shares" */ "../app/jsx/bundles/content_shares.js");
    
      case "context_module_progressions": return import(/* webpackChunkName: "context_module_progressions" */ "../app/jsx/bundles/context_module_progressions.js");
    
      case "context_modules": return import(/* webpackChunkName: "context_modules" */ "../app/jsx/bundles/context_modules.js");
    
      case "conversations_new": return import(/* webpackChunkName: "conversations_new" */ "../app/jsx/bundles/conversations_new.js");
    
      case "copy_course": return import(/* webpackChunkName: "copy_course" */ "../app/jsx/bundles/copy_course.js");
    
      case "course_grading_standards": return import(/* webpackChunkName: "course_grading_standards" */ "../app/jsx/bundles/course_grading_standards.js");
    
      case "course_link_validator": return import(/* webpackChunkName: "course_link_validator" */ "../app/jsx/bundles/course_link_validator.js");
    
      case "course_list": return import(/* webpackChunkName: "course_list" */ "../app/jsx/bundles/course_list.js");
    
      case "course_settings": return import(/* webpackChunkName: "course_settings" */ "../app/jsx/bundles/course_settings.js");
    
      case "course_statistics": return import(/* webpackChunkName: "course_statistics" */ "../app/jsx/bundles/course_statistics.js");
    
      case "course_wizard": return import(/* webpackChunkName: "course_wizard" */ "../app/jsx/bundles/course_wizard.js");
    
      case "course": return import(/* webpackChunkName: "course" */ "../app/jsx/bundles/course.js");
    
      case "dashboard_card": return import(/* webpackChunkName: "dashboard_card" */ "../app/jsx/bundles/dashboard_card.js");
    
      case "dashboard": return import(/* webpackChunkName: "dashboard" */ "../app/jsx/bundles/dashboard.js");
    
      case "deep_linking_response": return import(/* webpackChunkName: "deep_linking_response" */ "../app/jsx/bundles/deep_linking_response.js");
    
      case "developer_keys_react": return import(/* webpackChunkName: "developer_keys_react" */ "../app/jsx/bundles/developer_keys_react.js");
    
      case "developer_keys": return import(/* webpackChunkName: "developer_keys" */ "../app/jsx/bundles/developer_keys.js");
    
      case "discussion_topics_edit": return import(/* webpackChunkName: "discussion_topics_edit" */ "../app/jsx/bundles/discussion_topics_edit.js");
    
      case "discussion_topics_index_v2": return import(/* webpackChunkName: "discussion_topics_index_v2" */ "../app/jsx/bundles/discussion_topics_index_v2.js");
    
      case "discussion": return import(/* webpackChunkName: "discussion" */ "../app/jsx/bundles/discussion.js");
    
      case "edit_calendar_event": return import(/* webpackChunkName: "edit_calendar_event" */ "../app/jsx/bundles/edit_calendar_event.js");
    
      case "edit_rubric": return import(/* webpackChunkName: "edit_rubric" */ "../app/jsx/bundles/edit_rubric.js");
    
      case "eportfolio": return import(/* webpackChunkName: "eportfolio" */ "../app/jsx/bundles/eportfolio.js");
    
      case "epub_exports": return import(/* webpackChunkName: "epub_exports" */ "../app/jsx/bundles/epub_exports.js");
    
      case "external_apps": return import(/* webpackChunkName: "external_apps" */ "../app/jsx/bundles/external_apps.js");
    
      case "external_tool_redirect": return import(/* webpackChunkName: "external_tool_redirect" */ "../app/jsx/bundles/external_tool_redirect.js");
    
      case "file_inline": return import(/* webpackChunkName: "file_inline" */ "../app/jsx/bundles/file_inline.js");
    
      case "file_not_found_bundle": return import(/* webpackChunkName: "file_not_found_bundle" */ "../app/jsx/bundles/file_not_found_bundle.js");
    
      case "file_preview": return import(/* webpackChunkName: "file_preview" */ "../app/jsx/bundles/file_preview.js");
    
      case "file_show": return import(/* webpackChunkName: "file_show" */ "../app/jsx/bundles/file_show.js");
    
      case "focus_helper": return import(/* webpackChunkName: "focus_helper" */ "../app/jsx/bundles/focus_helper.js");
    
      case "gradebook_history": return import(/* webpackChunkName: "gradebook_history" */ "../app/jsx/bundles/gradebook_history.js");
    
      case "gradebook_uploads": return import(/* webpackChunkName: "gradebook_uploads" */ "../app/jsx/bundles/gradebook_uploads.js");
    
      case "gradebook": return import(/* webpackChunkName: "gradebook" */ "../app/jsx/bundles/gradebook.js");
    
      case "gradezilla": return import(/* webpackChunkName: "gradezilla" */ "../app/jsx/bundles/gradezilla.js");
    
      case "graphiql": return import(/* webpackChunkName: "graphiql" */ "../app/jsx/bundles/graphiql.js");
    
      case "group_submission_reminder": return import(/* webpackChunkName: "group_submission_reminder" */ "../app/jsx/bundles/group_submission_reminder.js");
    
      case "jobs": return import(/* webpackChunkName: "jobs" */ "../app/jsx/bundles/jobs.js");
    
      case "ldap_settings_test": return import(/* webpackChunkName: "ldap_settings_test" */ "../app/jsx/bundles/ldap_settings_test.js");
    
      case "learning_outcomes": return import(/* webpackChunkName: "learning_outcomes" */ "../app/jsx/bundles/learning_outcomes.js");
    
      case "license_help": return import(/* webpackChunkName: "license_help" */ "../app/jsx/bundles/license_help.js");
    
      case "link_enrollment": return import(/* webpackChunkName: "link_enrollment" */ "../app/jsx/bundles/link_enrollment.js");
    
      case "locale": return import(/* webpackChunkName: "locale" */ "../app/jsx/bundles/locale.js");
    
      case "login": return import(/* webpackChunkName: "login" */ "../app/jsx/bundles/login.js");
    
      case "manage_avatars": return import(/* webpackChunkName: "manage_avatars" */ "../app/jsx/bundles/manage_avatars.js");
    
      case "manage_groups2": return import(/* webpackChunkName: "manage_groups2" */ "../app/jsx/bundles/manage_groups2.js");
    
      case "media_player_iframe_content": return import(/* webpackChunkName: "media_player_iframe_content" */ "../app/jsx/bundles/media_player_iframe_content.js");
    
      case "messages": return import(/* webpackChunkName: "messages" */ "../app/jsx/bundles/messages.js");
    
      case "mobile_login": return import(/* webpackChunkName: "mobile_login" */ "../app/jsx/bundles/mobile_login.js");
    
      case "moderate_quiz": return import(/* webpackChunkName: "moderate_quiz" */ "../app/jsx/bundles/moderate_quiz.js");
    
      case "module_sequence_footer": return import(/* webpackChunkName: "module_sequence_footer" */ "../app/jsx/bundles/module_sequence_footer.js");
    
      case "navigation_header": return import(/* webpackChunkName: "navigation_header" */ "../app/jsx/bundles/navigation_header.js");
    
      case "not_found_index": return import(/* webpackChunkName: "not_found_index" */ "../app/jsx/bundles/not_found_index.js");
    
      case "notification_preferences": return import(/* webpackChunkName: "notification_preferences" */ "../app/jsx/bundles/notification_preferences.js");
    
      case "oauth2_confirm": return import(/* webpackChunkName: "oauth2_confirm" */ "../app/jsx/bundles/oauth2_confirm.js");
    
      case "otp_login": return import(/* webpackChunkName: "otp_login" */ "../app/jsx/bundles/otp_login.js");
    
      case "page_views": return import(/* webpackChunkName: "page_views" */ "../app/jsx/bundles/page_views.js");
    
      case "permissions_index": return import(/* webpackChunkName: "permissions_index" */ "../app/jsx/bundles/permissions_index.js");
    
      case "plugins": return import(/* webpackChunkName: "plugins" */ "../app/jsx/bundles/plugins.js");
    
      case "prerequisites_lookup": return import(/* webpackChunkName: "prerequisites_lookup" */ "../app/jsx/bundles/prerequisites_lookup.js");
    
      case "profile_show": return import(/* webpackChunkName: "profile_show" */ "../app/jsx/bundles/profile_show.js");
    
      case "profile": return import(/* webpackChunkName: "profile" */ "../app/jsx/bundles/profile.js");
    
      case "progress_pill": return import(/* webpackChunkName: "progress_pill" */ "../app/jsx/bundles/progress_pill.js");
    
      case "question_bank": return import(/* webpackChunkName: "question_bank" */ "../app/jsx/bundles/question_bank.js");
    
      case "question_banks": return import(/* webpackChunkName: "question_banks" */ "../app/jsx/bundles/question_banks.js");
    
      case "quiz_history": return import(/* webpackChunkName: "quiz_history" */ "../app/jsx/bundles/quiz_history.js");
    
      case "quiz_show": return import(/* webpackChunkName: "quiz_show" */ "../app/jsx/bundles/quiz_show.js");
    
      case "quiz_statistics_cqs": return import(/* webpackChunkName: "quiz_statistics_cqs" */ "../app/jsx/bundles/quiz_statistics_cqs.js");
    
      case "quiz_submission_events": return import(/* webpackChunkName: "quiz_submission_events" */ "../app/jsx/bundles/quiz_submission_events.js");
    
      case "quizzes_bundle": return import(/* webpackChunkName: "quizzes_bundle" */ "../app/jsx/bundles/quizzes_bundle.js");
    
      case "quizzes_index": return import(/* webpackChunkName: "quizzes_index" */ "../app/jsx/bundles/quizzes_index.js");
    
      case "react_collaborations": return import(/* webpackChunkName: "react_collaborations" */ "../app/jsx/bundles/react_collaborations.js");
    
      case "react_files": return import(/* webpackChunkName: "react_files" */ "../app/jsx/bundles/react_files.js");
    
      case "react_groups": return import(/* webpackChunkName: "react_groups" */ "../app/jsx/bundles/react_groups.js");
    
      case "react_outcome_alignment": return import(/* webpackChunkName: "react_outcome_alignment" */ "../app/jsx/bundles/react_outcome_alignment.js");
    
      case "registration_confirmation": return import(/* webpackChunkName: "registration_confirmation" */ "../app/jsx/bundles/registration_confirmation.js");
    
      case "registration": return import(/* webpackChunkName: "registration" */ "../app/jsx/bundles/registration.js");
    
      case "roster": return import(/* webpackChunkName: "roster" */ "../app/jsx/bundles/roster.js");
    
      case "rubric_assessment": return import(/* webpackChunkName: "rubric_assessment" */ "../app/jsx/bundles/rubric_assessment.js");
    
      case "screenreader_gradebook": return import(/* webpackChunkName: "screenreader_gradebook" */ "../app/jsx/bundles/screenreader_gradebook.js");
    
      case "section": return import(/* webpackChunkName: "section" */ "../app/jsx/bundles/section.js");
    
      case "select_content_dialog": return import(/* webpackChunkName: "select_content_dialog" */ "../app/jsx/bundles/select_content_dialog.js");
    
      case "self_enrollment": return import(/* webpackChunkName: "self_enrollment" */ "../app/jsx/bundles/self_enrollment.js");
    
      case "sis_import": return import(/* webpackChunkName: "sis_import" */ "../app/jsx/bundles/sis_import.js");
    
      case "slickgrid": return import(/* webpackChunkName: "slickgrid" */ "../app/jsx/bundles/slickgrid.js");
    
      case "speed_grader": return import(/* webpackChunkName: "speed_grader" */ "../app/jsx/bundles/speed_grader.js");
    
      case "student_group_dialog": return import(/* webpackChunkName: "student_group_dialog" */ "../app/jsx/bundles/student_group_dialog.js");
    
      case "styleguide": return import(/* webpackChunkName: "styleguide" */ "../app/jsx/bundles/styleguide.js");
    
      case "sub_accounts": return import(/* webpackChunkName: "sub_accounts" */ "../app/jsx/bundles/sub_accounts.js");
    
      case "submission_download": return import(/* webpackChunkName: "submission_download" */ "../app/jsx/bundles/submission_download.js");
    
      case "submissions": return import(/* webpackChunkName: "submissions" */ "../app/jsx/bundles/submissions.js");
    
      case "submit_assignment": return import(/* webpackChunkName: "submit_assignment" */ "../app/jsx/bundles/submit_assignment.js");
    
      case "syllabus": return import(/* webpackChunkName: "syllabus" */ "../app/jsx/bundles/syllabus.js");
    
      case "take_quiz": return import(/* webpackChunkName: "take_quiz" */ "../app/jsx/bundles/take_quiz.js");
    
      case "teacher_activity_report": return import(/* webpackChunkName: "teacher_activity_report" */ "../app/jsx/bundles/teacher_activity_report.js");
    
      case "terms_of_service_modal": return import(/* webpackChunkName: "terms_of_service_modal" */ "../app/jsx/bundles/terms_of_service_modal.js");
    
      case "terms_of_use": return import(/* webpackChunkName: "terms_of_use" */ "../app/jsx/bundles/terms_of_use.js");
    
      case "theme_editor": return import(/* webpackChunkName: "theme_editor" */ "../app/jsx/bundles/theme_editor.js");
    
      case "theme_preview": return import(/* webpackChunkName: "theme_preview" */ "../app/jsx/bundles/theme_preview.js");
    
      case "user_grades": return import(/* webpackChunkName: "user_grades" */ "../app/jsx/bundles/user_grades.js");
    
      case "user_lists": return import(/* webpackChunkName: "user_lists" */ "../app/jsx/bundles/user_lists.js");
    
      case "user_logins": return import(/* webpackChunkName: "user_logins" */ "../app/jsx/bundles/user_logins.js");
    
      case "user_name": return import(/* webpackChunkName: "user_name" */ "../app/jsx/bundles/user_name.js");
    
      case "user_notes": return import(/* webpackChunkName: "user_notes" */ "../app/jsx/bundles/user_notes.js");
    
      case "user_observees": return import(/* webpackChunkName: "user_observees" */ "../app/jsx/bundles/user_observees.js");
    
      case "user": return import(/* webpackChunkName: "user" */ "../app/jsx/bundles/user.js");
    
      case "visibility_help": return import(/* webpackChunkName: "visibility_help" */ "../app/jsx/bundles/visibility_help.js");
    
      case "webzip_export": return import(/* webpackChunkName: "webzip_export" */ "../app/jsx/bundles/webzip_export.js");
    
      case "wiki_page_edit": return import(/* webpackChunkName: "wiki_page_edit" */ "../app/jsx/bundles/wiki_page_edit.js");
    
      case "wiki_page_index": return import(/* webpackChunkName: "wiki_page_index" */ "../app/jsx/bundles/wiki_page_index.js");
    
      case "wiki_page_revisions": return import(/* webpackChunkName: "wiki_page_revisions" */ "../app/jsx/bundles/wiki_page_revisions.js");
    
      case "wiki_page_show": return import(/* webpackChunkName: "wiki_page_show" */ "../app/jsx/bundles/wiki_page_show.js");
    

    default:
      throw new Error("couldn't find bundle " + bundleName)
  }
}
